export default {
  text: '{{threshold}} kuukausimyynti: {{amount}}',
  label: '{{threshold}} kuukausimyynti:',
  no_discount: 'ei alennusta',
  discount_badge: '-{{percentage}}%',
};
